import './index.css';
import './styles/common.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { SubmittedFlagProvider } from './components/common/StatusContext';

import { CookiesProvider } from 'react-cookie';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <CookiesProvider>
      <SubmittedFlagProvider>
      <App />
      </SubmittedFlagProvider>
    </CookiesProvider>
  </React.StrictMode>
);